import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { BaseGeneralComponent } from 'src/app/BaseGeneralComponent';
import { ContractTypeService } from 'src/app/general-services/service-contract-type/contract-type.service';
import { LoaderService } from 'src/app/general-services/service-loader/loader.service';
import { LocalCustomerAnagrafService } from 'src/app/general-services/service-local-customer-anagraf/local-customer-anagraf.service';
import { NumAnnoMeseService } from 'src/app/general-services/service-num-anno-mese/num-anno-mese.service';
import { RegionService } from 'src/app/general-services/service-region-anagraf/region-service.service';
import { ResourceUnitService } from 'src/app/general-services/service-resources-units-anagraf/resource-unit.service';
import { Sl1AnagrafService } from 'src/app/general-services/service-sl1-services/sl1-anagraf.service';
import { ConsuntivoVolumiService } from 'src/app/monthly-actual/consuntivo-volumi/service-consuntivo-volumi/consuntivo-volumi.service';
import { AllSettingsFilterModel } from 'src/models/AllSettingsFilterModel';
import { MatDialog } from '@angular/material/dialog';
import { ConstuntivoVolumiStorargeModel, ConsuntivoVolumiModel, ConsuntivoVolumiReportModel } from 'src/models/ConsuntivoVolumiModel';
import { NumAnnoMeseFilterComponent } from 'src/app/general-components/filter/num-anno-mese-filter/num-anno-mese-filter.component';
import { ReferenceMonthFilterComponent } from 'src/app/general-components/filter/reference-month-filter/reference-month-filter.component';
import { LocalCustomerFilterComponent } from 'src/app/general-components/filter/local-customer-filter/local-customer-filter.component';
import { RegionFilterComponent } from 'src/app/general-components/filter/region-filter/region-filter.component';
import { ResourceUnitFilterComponent } from 'src/app/general-components/filter/resource-unit-filter/resource-unit-filter.component';
import { ContractTypeFilterComponent } from 'src/app/general-components/filter/contract-type-filter/contract-type-filter.component';
import { Sl1FilterComponent } from 'src/app/general-components/filter/sl1-filter/sl1-filter.component';
import { ActualQuantityFilterComponent } from 'src/app/general-components/filter/actual-quantity-filter/actual-quantity-filter.component';
import { WorkflowStatusFilterComponent } from 'src/app/archive/workflow-status-filter/workflow-status-filter.component';
import { FormControl } from '@angular/forms';
import { Offset } from 'src/models/Offset';
import * as toastr from 'toastr';
import * as FileSaver from 'file-saver';
import { DialogSendEmailComponent } from 'src/app/general-components/dialog-send-email/dialog-send-email.component';
import { GenericArray } from 'src/models/GenericArray';
import { DialogYearMonthComponent } from 'src/app/general-components/dialog-year-month/dialog-year-month.component';
import { ConsuntivoForecastService } from '../../service-consuntivo-forecast/consuntivo-forecast.service';

@Component({
  selector: 'app-filter-consuntivo-forecast',
  templateUrl: './filter-consuntivo-forecast.component.html',
  styleUrls: ['./filter-consuntivo-forecast.component.scss']
})
export class FilterConsuntivoForecastComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  @Input() numAnnoMeseData?: any;
  @Input() filter?: ConsuntivoVolumiModel;
  @Input() reportSection?: boolean;
  @Input() isRecovery?: boolean;
  @Input() isComparing?: boolean;
  @Input() isError?: boolean;
  @Input() isArchive?: boolean;

  
  contractTypeData?: any;
  regionData: any;
  localCustomerData: any;
  resourceUnitData: any;
  designServiceData: any;

  @Output() dataFiltered = new EventEmitter<any>();
  @Output() resetDataFiltered = new EventEmitter<any>();
  
  @ViewChild(NumAnnoMeseFilterComponent, { static: true }) numAnnoFilterComponent;
  @ViewChild(ReferenceMonthFilterComponent, { static: true }) referenceMonthFilterComponent;
  @ViewChild(LocalCustomerFilterComponent) localCustomerFilterComponent;
  @ViewChild(RegionFilterComponent, { static: true }) regionFilterComponent;
  @ViewChild(ResourceUnitFilterComponent, { static: true }) resourceUnitFilterComponent;
  @ViewChild(ContractTypeFilterComponent, { static: true }) contractTypeFilterComponent;
  @ViewChild(Sl1FilterComponent, { static: true }) designServicesFilterComponent;
  // @ViewChild(ActualQuantityFilterComponent, { static: true }) actualQuantityFilterComponent;
  @ViewChild(WorkflowStatusFilterComponent) workFlowStatusFilterComponent;

  filterSingle: AllSettingsFilterModel;
  shareNameFormControl = new FormControl();
  applicationDescriptionFormControl = new FormControl();
  labelAnnoMeseRif: string;
  getNameSubscribe: Subscription;
  downloadSubscribe: Subscription;
  offset: Offset;
  fileName: string;
  intermittentBool: boolean;
  actualQuantityFilter: number;

  constructor(private loaderService: LoaderService,
              private consuntivoForecastService: ConsuntivoForecastService,
              private numAnnoMeseService: NumAnnoMeseService,
              private regionService: RegionService,
              private localCustomerService: LocalCustomerAnagrafService,
              private contractTypeService: ContractTypeService,
              private resourceUnitService: ResourceUnitService,
              private sl1AnagrafService: Sl1AnagrafService,
              private dialog: MatDialog) {
    super();
    this.loaderService.display(true);
  }
  

  ngOnInit(): void {
    if (!this.filter) {
      this.filter = new ConsuntivoVolumiModel();
    }
    this.filter.provider =  JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filterSingle = AllSettingsFilterModel.getFromConsuntivoVolumiModel(this.filter);

    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    this.labelAnnoMeseRif = 'Reference Month';
    if (JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.VOLUME_CONSUMPTIVE_FILTER))) {
      const filterStorage: ConstuntivoVolumiStorargeModel = JSON.parse(
        sessionStorage.getItem(this.SESSION_STORAGE_LABELS.VOLUME_CONSUMPTIVE_FILTER)
      );
      this.filter = filterStorage;
      this.actualQuantityFilter = filterStorage.actualQuantityFilter;
      this.shareNameFormControl.setValue(this.filter.shareName);
      this.applicationDescriptionFormControl.setValue(this.filter.applicationDescription);
    } else {
      this.actualQuantityFilter = 1;
      this.filter.actualQuantityFilter = 1;
    }

    this.initFilter(this.filterSingle);
  }

  initFilter(allSettingsFilterModel: AllSettingsFilterModel, isReset?: boolean) {
    const getAllRegionObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllLocalCustomerObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllContractTypeObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllResourceUnitObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllDesignServicesObservable: Observable<any> = this.sl1AnagrafService.getListInAllSettings(
      this.sl1AnagrafService.baseUrl,
      allSettingsFilterModel).pipe();

    forkJoin([getAllRegionObservable, getAllLocalCustomerObservable, getAllContractTypeObservable,
              getAllResourceUnitObservable, getAllDesignServicesObservable])
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.contractTypeData = resultFork[2];
          this.resourceUnitData = resultFork[3];
          this.designServiceData = resultFork[4];

          if (!isReset) {
            this.loaderService.display(false);
          } else {
            this.dataFiltered.emit({filter: this.getFilterItem(), actualQuantityFilter: this.actualQuantityFilter});
          }

        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  private getFilterItem() {
    const filterItem = this.filter;
    if (!this.isArchive) {
      filterItem.workflowStatus = undefined;
    }
    return filterItem;
  }

  interceptNumAnnoMeseChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptNumAnnoMeseFromChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptContractTypeChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.contractType = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();
    const getAllDesignServicesObservable: Observable<any> = this.sl1AnagrafService.getListInAllSettings(
      this.sl1AnagrafService.baseUrl,
      this.filterSingle).pipe();

    // observableList.push(getAllNumAnnoMeseFilteredObservable);
    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllResourceUnitFilteredObservable);
    observableList.push(getAllDesignServicesObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.resourceUnitData = resultFork[2];
          this.designServiceData = resultFork[3];

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;
          this.filter.designServices = this.filterSingle.sl1;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptRegionChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.region = event;

    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();
    const getAllDesignServicesObservable: Observable<any> = this.sl1AnagrafService.getListInAllSettings(
      this.sl1AnagrafService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllResourceUnitFilteredObservable);
    observableList.push(getAllDesignServicesObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.localCustomerData = resultFork[0];
          this.contractTypeData = resultFork[1];
          this.resourceUnitData = resultFork[2];
          this.designServiceData = resultFork[3];

          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.contractType = this.filterSingle.contractType;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;
          this.filter.designServices = this.filterSingle.sl1;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptLocalCustomerChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.localCustomer = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();
    const getAllDesignServicesObservable: Observable<any> = this.sl1AnagrafService.getListInAllSettings(
      this.sl1AnagrafService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllResourceUnitFilteredObservable);
    observableList.push(getAllDesignServicesObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.contractTypeData = resultFork[1];
          this.resourceUnitData = resultFork[2];
          this.designServiceData = resultFork[3];

          this.filter.region = this.filterSingle.region;
          this.filter.contractType = this.filterSingle.contractType;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;
          this.filter.designServices = this.filterSingle.sl1;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  isLocalCustomerFilterActive(): boolean {
    if (this.filter && this.filter.provider && this.filter.provider.cod) {
      return this.filter.provider.cod !== 'DXC';
    }
    console.error('no provider found');
    return false;
  }

  interceptResourceUnitChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.resourceUnit = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const getAllDesignServicesObservable: Observable<any> = this.sl1AnagrafService.getListInAllSettings(
      this.sl1AnagrafService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllDesignServicesObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.contractTypeData = resultFork[2];
          this.designServiceData = resultFork[3];

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.contractType = this.filterSingle.contractType;
          this.filter.designServices = this.filterSingle.sl1;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptDesignServicesChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.sl1 = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllResourceUnitFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.contractTypeData = resultFork[2];
          this.resourceUnitData = resultFork[3];

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.contractType = this.filterSingle.contractType;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptActualQuantityFilterChange($event) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  getAllFilters() {
    if (!this.reportSection) {
      this.filter.numAnnoMese = this.numAnnoFilterComponent.optionSelected;
    }
    this.filter.region = this.regionFilterComponent.getSelectedObject();
    this.filter.localCustomer = this.localCustomerFilterComponent ? this.localCustomerFilterComponent.getSelectedObject() : null;
    this.filter.contractType = this.contractTypeFilterComponent.getSelectedObject();
    this.filter.resourceUnit = this.resourceUnitFilterComponent.getSelectedObject();
    this.filter.designServices = this.designServicesFilterComponent.getSelectedObject();
    this.loaderService.display(false);
  }

  generateConsuntivoVolumiXlsx(reportFilter) {
    let fileName = 'Monthly Forecast';
    if (this.filter.isRecovery) {
      fileName = 'Forecast Balance';
    } else if (this.isComparing) {
      fileName = 'Preliminary vs Final';
    } else if (this.isError) {
      fileName = 'Monthly Forecast Errors';
    }
    this.getNameSubscribe = this.consuntivoForecastService.getNameGenerateXlsx(this.offset, reportFilter, this.isComparing)
      .subscribe(
        resultPage => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([resultPage],
                { type: this.EXCEL_TYPE }),
              fileName + ' - ' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob([resultPage], { type: this.EXCEL_TYPE }),
              fileName + ' - ' + currentDate + ' From ' + reportFilter.numAnnoMeseFrom + ' To ' + reportFilter.numAnnoMeseTo + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');
          this.loaderService.display(false);
        }, () => {
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }


  downloadXlsx() {
    this.getAllFilters();
    const reportFilter = this.filter as ConsuntivoVolumiReportModel;
    if (this.reportSection) {
      reportFilter.numAnnoMeseTo = this.numAnnoFilterComponent.optionSelected;
      reportFilter.numAnnoMeseFrom = this.numAnnoFilterComponent.optionSelectedFrom;
    } else {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMese;
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMese;
    }
    if (!reportFilter.numAnnoMeseFrom && reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMeseTo;
    } else if (reportFilter.numAnnoMeseFrom && !reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMeseFrom;
    } else {
      console.error('year month filter is missing');
    }
    this.offset.actualQuantityFilter = this.actualQuantityFilter;

    this.loaderService.display(true);
    this.generateConsuntivoVolumiXlsx(reportFilter);
  }

  shareXlsx() {
    this.getAllFilters();
    const reportFilter = this.filter as ConsuntivoVolumiReportModel;
    if (this.reportSection) {
      reportFilter.numAnnoMeseTo = this.numAnnoFilterComponent.optionSelected;
      reportFilter.numAnnoMeseFrom = this.numAnnoFilterComponent.optionSelectedFrom;
    } else {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMese;
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMese;
    }
    if (!reportFilter.numAnnoMeseFrom && reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMeseTo;
    } else if (reportFilter.numAnnoMeseFrom && !reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMeseFrom;
    } else {
      console.error('Year month filter is missing.');
    }
    this.offset.actualQuantityFilter = this.actualQuantityFilter;

    const dialogRef = this.dialog.open(DialogSendEmailComponent, {
      data: {
        currentBaseUrl: this.consuntivoForecastService.baseUrl,
        isComparing: this.isComparing,
        offset: this.offset,
        filter: reportFilter
      }
    });
  }

  getDate() {
    const date = new Date();
    return date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0');
  }

  filterTable(): void {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    this.getAllFilters();
    if (!this.reportSection) {
      const filterStorage: ConstuntivoVolumiStorargeModel = this.filter as ConstuntivoVolumiStorargeModel;
      filterStorage.actualQuantityFilter = this.actualQuantityFilter;
      sessionStorage.setItem(this.SESSION_STORAGE_LABELS.VOLUME_CONSUMPTIVE_FILTER, JSON.stringify(filterStorage));
    }
    this.dataFiltered.emit({filter: this.getFilterItem(), actualQuantityFilter: this.actualQuantityFilter, isComparing: this.isComparing});
  }

  openDialogDownloadXlsx() {
    if (this.reportSection) {
      this.filterTable();
    }
    this.getAllFilters();

    this.offset.actualQuantityFilter = this.actualQuantityFilter;

    const list: GenericArray[] = [
        {id: 'filter', value: this.filter},
        {id: 'offset', value: this.offset},
        {id: 'numAnnoMeseData', value: this.numAnnoMeseData},
        {id: 'serviceReportPage', value: this.SERVICE_REPORT_DOWNLOAD.CONSUNTIVO_VOLUMI},
        {id: 'quotationRequest', value: undefined},
        {id: 'comparing', value: this.isComparing}
      ],
      dialogRef = this.dialog.open(DialogYearMonthComponent, {
        data: {list}
      });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  reset() {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const isReset = true;
    this.filter = new ConsuntivoVolumiModel();
    this.filter.provider =  JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filter.isRecovery = this.isRecovery;

    this.filter.numAnnoMeseRif = null;
    this.filter.contractType = null;
    this.filter.region = null;
    this.filter.resourceUnit = null;
    this.filter.workflowStatus = null;

    this.contractTypeFilterComponent.reset();
    this.regionFilterComponent.reset();
    this.resourceUnitFilterComponent.reset();
    if (this.workFlowStatusFilterComponent) {
      this.workFlowStatusFilterComponent.reset();
    }

    this.filterSingle = AllSettingsFilterModel.getFromConsuntivoVolumiModel(this.filter);

    this.applicationDescriptionFormControl.setValue(this.filter.applicationDescription);
    this.shareNameFormControl.setValue(this.filter.shareName);

    this.numAnnoMeseService.getAllMonth(this.filter.provider, this.filter.contractType).subscribe(
      (resultYearMonth: any) => {
        this.numAnnoMeseData = resultYearMonth;

        const providerDefault = this.filter.provider;
        this.numAnnoMeseData =  this.filterFromDxc(providerDefault, resultYearMonth);

        const numAnnoMese = this.numAnnoMeseData[0] ? this.numAnnoMeseData[0] : null;
        this.filter.numAnnoMese = numAnnoMese;

        this.actualQuantityFilter = null;

        const filterStorage: ConstuntivoVolumiStorargeModel = this.filter as ConstuntivoVolumiStorargeModel;
        filterStorage.actualQuantityFilter = this.actualQuantityFilter;

        sessionStorage.setItem(this.SESSION_STORAGE_LABELS.VOLUME_CONSUMPTIVE_FILTER, JSON.stringify(this.filter));
        this.filterSingle = AllSettingsFilterModel.getFromConsuntivoVolumiModel(this.filter);

        this.initFilter(this.filterSingle, isReset);

        this.loaderService.display(false);
      }, error => {
        console.log(error);
        this.loaderService.display(false);
     });
  }

  ngOnDestroy(): void {
  }
}
